// @Deprecated - usage only in Portal
export enum CustomerType {
  Residential = 'Residential',
  Contractor = 'Contractor',
  Commercial = 'Commercial',
}

export enum CustomerTypes {
  // None = 0,
  Residential = 1,
  Contractor = 2,
  Commercial = 4,
  // All = 7,
}
